//BACKUP FOR LIVE SITE Jan 23 2025
import React, { Component } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import {
  SHOW_CALF, SIMPLE_VAL2, CHECK_TOKEN, SHOW_TOAST, FB_URL
} from '../store/actions/types'
import { showCalf } from '../store/actions/calfActions'
import { convertToken, getMyToken, createToken, getAdmin, checkToken } from '../store/actions/companyAdminActions'
import AddMyTokensDialog from '../components/Dialogs/AddMyTokensDialog'
//components/Dialogs/AddMyTokensDialog.js
import ReactPlayer from 'react-player'
import img1 from './eximg/img1a.jpg'
import img2 from './eximg/img2.jpg'
import img3 from './eximg/img3.jpg'
import * as qs from 'qs'
import GenTutorial from './PointsSurveys/GenTutorial'
import {
  isMobile,
  isBrowser
} from 'react-device-detect'
import { simpleValAction2 } from '../store/actions/simpleValAction2'
import { showToast } from '../store/actions/toastAction'
//import GetUserField from './GetPatron'
import firebase from '../store/firebase'
import { query, orderByChild, equalTo, get, ref } from "firebase/database";

import { initializeApp } from 'firebase/app';
import { getAuth, updateUser } from "firebase/auth";
import { signOut } from '../store/actions/authActions'
import PrevPage from './PrevPage'
import     './Sendmecoins.js';
import CryptoJS from 'crypto-js';
import moment from 'moment-timezone';
// import url from 'url'
// import patreonAPI, { oauth as patreonOAuth } from 'patreon'
import { getFunctions, httpsCallable } from "firebase/functions";

class Gotopatreon extends React.Component {
  state = {
    code: null,
    calfmember: false,
    tokenData: null,
    success: true,
    openDialog: false,
    tokenRex: false,
    oauthGrantCode: false,
    NewWalletAddress: '',
    PrivateKey: '',
    coinsBought: 0,
    mevInWallet: '',
    walletAddress: '',
    mevCoinPriceInUSD: '',
    pledgeStart: null
  };

  constructor(props) {
    super(props)
   // this.confirmPledge = this.confirmPledge.bind(this);
   if ( this.props.rep===true ) {this.props.history.push('/gotopatreon')} //correct url to use oauthGrantCodex

  //  var url1 = window.location.href;
  //  var urly = url1.substring(
  //    url1.indexOf("=") + 1, 
  //    url1.lastIndexOf("&")
  //  );
  //   if (urly===false) {
     
  //   } else {
  //    if ( this.props.rep===true ) {this.props.history.push('/gotopatreon')} 
  //   }

    // this.sendGetRequest(this.props.calfemail, this.props, '2') //set onething = true if on calf databse
  }

  askPermission = () => {
    const { tokenRequested} = this.props
    // this.props.loadingAction({
    //   leaderboard_loading: 1,
    //   type: LEADERBOARD_LOADING
    // })
    const promise = this.getPermission()
    promise.then(this.onFulfilled, this.onRejected)
  }

  handleCloseDialog = () => {
    
    this.setState({ openDialog: !this.state.openDialog })
  };

///////////////////////////////////////////
getOwnerProps(props, typ) {
   
  for (let x in props) {
    switch(typ) {
      case 'email':
        return props[x].email
        break;
      case 'firstName':
        return props[x].firstName
        break;
      case 'lastName':
        return props[x].lastName
        break;
      case 'companyID':
        return props[x].companyID
        break;
      case 'userID':
        return props[x].userID
        break;
      default:
        // code block
    }
  }
}

loadTokenA = (params, data) => {
  // if (this.props.adminAcc) {
   const promise = this.loadTokenB(params, data)
   promise.then(this.onFulfilled, this.onRejected)
 // } 
}

loadTokenB = (params, data) => {
  const { createToken } = this.props
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (this.state.success) {
        let data = {
          email: this.getOwnerProps(this.props.adminAcc, 'email'),
          firstName: this.getOwnerProps(this.props.adminAcc, 'firstName'),
          lastName: this.getOwnerProps(this.props.adminAcc, 'lastName'),
          companyID: this.getOwnerProps(this.props.adminAcc, 'companyID'),
          userID: this.getOwnerProps(this.props.adminAcc, 'userID'),
    
          personID: this.props.userdata.userID, //token sent to
          personName: this.props.userdata.firstName,
          personLastName: this.props.userdata.lastName,
          personEmail: this.props.userdata.email,
          tokenType: params.tokenType,
         // amount: this.props.amount
        } 
          
         if (data.email) {
          createToken(data);
          } 
         else
         {
          }
      } else {
        reject('Failed to the user list')
      }
    }, 10000)
  })
}

  handleSubmitUser = async usersData => {
    const { getAdmin, userdata } = this.props
     let data = {companyID: userdata.companyID}
     this.setState({tokenRex: true})

     let paramsX = {
      type: SHOW_TOAST,
      open: true,
      variant: 'success',
      message: 'Your Token has been Requested. Please wait a moment.'
    }

    this.props.showToast(paramsX)

     await getAdmin(data);

    let params={
      tokenType: usersData.tokenType
    }
    this.loadTokenA(params, data)

       // this.handleCloseDialog()
  };

  getPermission = () => {
    const { convertToken, onething, simpleValAction2, getMyToken, mytoken, tokenRequested } = this.props
    var tokentext
    var tok;

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (this.state.success) {
          // if (this.state.calfmember === true && this.props.userdata.from !== 'StrategyX') { // FIRST TIME GOING THROUGH
         // && this.props.userdata.from !=='StrategyX'
             if (this.props.mytoken && tokenRequested === 'yes' && this.props.onething === true ) { // FIRST TIME GOING THROUGH means user is on calf database
            //token requested and payment already made
            //CALF PRODUCTS MODIFY HERE
            if (this.props.mytoken.tokenType === 'app') { tokentext = 'ThinkLead app' }
            if (this.props.mytoken.tokenType === 'ex1') { tokentext = 'Executive Club 1' }
            if (this.props.mytoken.tokenType === 'ex2') { tokentext = 'Executive Club 2' }

            tok = this.props.mytoken.token

            // const answerToken = prompt(
            //   'Please provide a Token to join the Executive Club.'
            //   + ' You have purchased the ' + tokentext + '. ' + 
            //   'Here is your token: ' + tok + '', tok
            // )
            answerToken = 'yes'
           // if (answerToken === '' || answerToken === null || answerToken === 'no') {
           // } else {
              
              this.sendGetRequest(this.props.calfemail, this.props, '3') //set execmember=true & open EC
              let val = {
                token: answerToken,
                userID: this.props.userdata.userID
              }
              convertToken(val)  // CONVERT TOKEN TO CREDIT
           // }
          }
          else {

            
          }
        } 
        else {
          reject('Failed to the user list')
        }
      }, 6000)
    })
  }

  findTokenA = () => {
    
    const promise = this.findTokenB()
    promise.then(this.onFulfilled, this.onRejected)
  }
  
  findTokenB = () => {
    const { tokenRequested } = this.props
   
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (this.state.success) {
          
        
          if (tokenRequested==='no' || tokenRequested===undefined) {
            this.setState({openDialog: true})
           }
        } else {
          reject('Failed to the user list')
        }
      }, 6000)
    })
  }
//////////////////////////////////////////////////////////////////////////////////////////
// handleOAuthRedirectRequest(request, response) {
//   // const CLIENT_ID = null     // Replace with your data
//   // const CLIENT_SECRET = null // Replace with your data
//   // const redirectURL = null   // Replace with your data

//   const redirectURL = 'https://thinklead.app'; //'http://localhost:3000/callback'; // This should match your redirect URI in the Patreon Developer Dashboard
//   const CLIENT_ID = '4uk2TdW-YL2r-YB-sVcqw9jzGQhzZX-YFJs6b10hR372n5qjoQG0PsLLfIvga-Ti'     // Replace with your data
//   const CLIENT_SECRET = 'aQdMxoIIhT_NWoiKgxmD_KBcmzshHDkKvYD_7W5-UZS62DGTwlFDM79exw2NmbIn' 

//   const patreonOAuthClient = patreonOAuth(CLIENT_ID, CLIENT_SECRET)
//   const oauthGrantCode = url.parse(request.url, true).query.code

//     patreonOAuthClient
//         .getTokens(oauthGrantCode, redirectURL)
//         .then(tokensResponse => {
//             const patreonAPIClient = patreonAPI(tokensResponse.access_token)
//             return patreonAPIClient('/current_user')
//         })
//         .then(({ store }) => {
//             response.end(store.findAll('user').map(user => user.serialize()))
//         })
//         .catch(err => {
//             response.end(err)
//         })
// }

//     //Get the raw json from the response. See for the expected format of the data
//     patreon_response = patreon_client('/current_user').then(function(result) {
//       user_store = result.store
//       const data = result.rawJson
//       /*  data.data will contain the current_user, but there might be more users returned and loaded into the store.
//       *  Get the id of the requested user, and find it in the store
//       */
//       const myUserId = data.data.id
//       creator = user_store.find('user', myUserId)
//     })

  getSubstring(string, char1, char2) {
    return string.slice(
      string.indexOf(char1) + 1,
      string.lastIndexOf(char2),
    );
  }
  
  makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * 
  charactersLength));
    }
    return result;
  }

  encryptPrivateKey = (privateKey) => {
    const passphrase = "Lead54321";
    // Convert the private key to a WordArray (binary format)
    const wordArray = CryptoJS.enc.Hex.parse(privateKey.slice(2)); // Remove the "0x" prefix
    return CryptoJS.AES.encrypt(wordArray, passphrase).toString();
  }
  
  decryptPrivateKey = (encryptedKey) => {
    const passphrase = "Lead54321";
    
  
    try {
      // Decrypt the encrypted key
      const bytes = CryptoJS.AES.decrypt(encryptedKey, passphrase);
      // Convert the decrypted WordArray back to a hex string
      const decryptedHex = CryptoJS.enc.Hex.stringify(bytes);
  
      if (!decryptedHex) {
        throw new Error("Decryption failed. The resulting string is empty.");
      }
  
      // Add back the "0x" prefix to match the original format
      const decrypted = `0x${decryptedHex}`;
  
      
      return decrypted;
    } catch (error) {
      
      return null; // or handle the error as needed
    }
  };  


  // async MakeWallet() { //orriginal function before setTimeOut
  //   var userwalletaddress = 'xxx';
  //   const updates = {};
  //   // const userID = this.props.userdetails[0].userID;
  //   // const uid = this.props.userdetails[0].uid;

  //   const userID = this.props.userdata.userID;
  //   const uid = this.props.userdata.uid;

  //   var walletAddress;
  //   var privateKey;
  //   var privateKeyEncrypted;

    
  //   // const userwalletaddress = this.props.wallet;//address of user buying coins
  //          await axios
  //          .post(`${FB_URL}/m107-mywallet`, {params: { 
  //              wallet: userwalletaddress //user wallet address
  //            } })
  //          .then(res => {
               
  //             // walletData = 'BINGO';
  //             walletAddress = res.data.NewWalletAddress;
  //             privateKey = res.data.PrivateKey;
  //             privateKeyEncrypted = this.encryptPrivateKey(privateKey);

              
              

  //             // NewWalletAddress: res.data.NewWalletAddress,
  //             // PrivateKey: res.data.PrivateKey
               
  //             //    NewWalletAddress: res.data.NewWalletAddress,
  //             //    PrivateKey: res.data.PrivateKey
  //             //  });
  //        ///////////////////////////////////////////////////////////////////////
         
         
  //       if (res.data.NewWalletAddress) {

  //        updates['/user/' + uid + '/wallet'] = res.data.NewWalletAddress;
  //        updates['/user/' + uid + '/privateKey'] = privateKeyEncrypted;//res.data.PrivateKey;

  //        updates['/users/' + userID + '/wallet'] = res.data.NewWalletAddress;
  //        updates['/users/' + userID + '/privateKey'] = privateKeyEncrypted;//res.data.PrivateKey;

  //        firebase.database.ref().update(
  //           updates,
  //           function (error) {
  //             if (error) {
                
  //             } else {
                   
  //             // return '1oxdf345c3456b5467' + testvar 
  //             return {
  //               NewWalletAddress: walletAddress,
  //               PrivateKey: privateKeyEncrypted
  //             };    
  //             }
  //           })         
  //           }           
  //         })
  //        // return '5oxdf345c3456b5467' + walletData 

  //        //this.setState({
  //        // walletAddress: walletAddress
  //        //})

  //        return {
  //         NewWalletAddress: walletAddress,
  //         PrivateKey: privateKeyEncrypted
  //       };
  //      }

async SendMeVisionCoin(userwalletaddress, amount) {
 // const userwalletaddress = this.props.wallet;//address of user buying coins
     await axios
        .post(`${FB_URL}/m106-sendmevcoin`, {params: { 
            wallet: userwalletaddress, //user wallet address
            n: '111', 
            amount: amount //number of coins to buy
          } })
        .then(res => {
            
        })
    }

    async BuyMeVisionCoin_test(userwalletaddress, amount) {
          
                 this.setState({
                  coinsBought: res.data.amountofcoinspurchased,
                  mevCoinPriceInUSD: res.data.mevCoinPriceInUSD
                 });      
         }

         async BuyMeVisionCoin(userwalletaddress, privKey, amount) {
           var TotMev;
              var finalAmount = (Number(amount)) / 100;
              
                 await axios
                 .post(`${FB_URL}/m108-buymevision`, {params: { 
                     wallet: userwalletaddress, //user wallet address
                     privateKey: privKey, 
                     amount: finalAmount //$$ sent to buy coins
                   } })
                 .then(res => {
                     
                     TotMev = res.data.mevInWallet;
                     this.setState({
                      bnbSentTransactionHash: res.data.bnbSentTransactionHash,
                      amountOfCoinsPurchased: res.data.amountOfCoinsPurchased,
                      totalGasFeesInUSD: res.data.totalGasFeesInUSD,// Display gas fees in MEV tokens
                      mevInWallet: res.data.mevInWallet, // Display MEV tokens in user wallet
                      mevCoinPriceInUSD: 0.2
                     });
                     return '1 - ' + TotMev;
                 })
                 return '2 - ' + TotMev;
             }
  
// checkAndUpdatePledgeStartC = async (uid) => {
//   //const userRef = firebase.database().ref(`user/${uid}`);
//   const userRef = firebase.database.ref('user/' + uid);

//   try {
//     const snapshot = await userRef.once("value");

//     if (!snapshot.exists()) {
//       return false;
//     }

//     const userData = snapshot.val();
//     let pledgeStart = Number(userData.pledgeStart) || 0;
//     const now = Date.now();

//     if (pledgeStart > 0 && pledgeStart < 1e12) {
//       pledgeStart *= 1000; // Convert to milliseconds if stored as seconds
//     }

//     let minSinceStart = pledgeStart > 0 ? Math.floor((now - pledgeStart) / (1000 * 60)) : 20;


//     if (minSinceStart < 2) {
//       return false;
//     }


//     await userRef.child("pledgeStart").set(now);

//     const checkSnapshot = await userRef.once("value");

//     return true;
//   } catch (error) {
//     return false;
//   }
// };


  checkAndUpdatePledgeStart = async (uid) => {
    const userRef = firebase.database.ref('user/' + uid);
    var updates = {};
      //const db = getDatabase();
      //const userRef = ref(db, `user/${uid}`);
      
      try {
        //const snapshot = await get(userRef);
        const snapshot = await userRef.once('value');

        
        // const snapshot = await userRef.once('value');
        if (!snapshot.exists()) {
          
          return false;
        }
        

        const userData = snapshot.val();
        const pledgeStart = Number(userData.pledgeStart) || 0; // Ensure it's a number
        const now = Date.now();
        
        
        
        

        
        
        
        let minSinceStart;
    
        if (pledgeStart) {
          minSinceStart = Math.floor((now - pledgeStart) / (1000 * 60)); // Round down to the nearest whole minute
        } else {
          minSinceStart = 20; // Default to 20 minutes if pledgeStart is missing
        }
    
        
    
        if (minSinceStart < 5) {
          return false;
        }
       
          updates['/user/' + uid + '/pledgeStart'] = now;
          await firebase.database.ref().update(updates);
          return true;
       
       // await update(userRef, { pledgeStart: now });
       // await firebase.database.ref().update(updates);
        

        return true;
      } catch (error) {
        
        return false;
      }
    };

    checkAndUpdatePledgeStartB = async (uid) => {
      const userRef = firebase.database().ref('user/' + uid); // Fix incorrect ref syntax
      let updates = {};
    
      
    
      try {
        const snapshot = await userRef.once('value');
    
        if (!snapshot.exists()) {
          
          return false;
        }
    
        const userData = snapshot.val();
        
        // Ensure pledgeStart is a number and correctly formatted in milliseconds
        let pledgeStart = Number(userData.pledgeStart) || 0;
        
        if (pledgeStart > 0 && pledgeStart < 1e12) {
          pledgeStart *= 1000; // Convert seconds to milliseconds if necessary
        }
    
        const now = Date.now();
        
        
        
    
        let minSinceStart = pledgeStart > 0 ? Math.floor((now - pledgeStart) / (1000 * 60)) : 20;
    
        
    
        if (minSinceStart < 10) {
          return false;
        }
    
        updates[`/user/${uid}/pledgeStart`] = now;
        await firebase.database().ref().update(updates);
        
        
    
        return true;
      } catch (error) {
        
        return false;
      }
    };
    
    checkAndUpdatePledgeStartD = async (uid) => {
      const userRef = firebase.database.ref('user/' + uid);
      
      
      try {
          const snapshot = await userRef.once('value');
          if (!snapshot.exists()) {
              
              return false;
          }
  
          const userData = snapshot.val();
          const pledgeStart = Number(userData.pledgeStart) || 0;
          const now = Date.now();
  
          
          
          
          
  
          let minSinceStart = pledgeStart ? Math.floor((now - pledgeStart) / (1000 * 60)) : 20;
  
          
  
          // ✅ Only update if at least 10 minutes have passed
          if (minSinceStart < 2) {
              
              return false;
          }
  
          
          await userRef.update({ pledgeStart: now });
  
          return true;
      } catch (error) {
          
          return false;
      }
  };
   

    //////////////////////////////////////////////////
    // checkAndUpdatePledgeStart = async (uid) => {
    //   const userRef = firebase.database().ref('user/' + uid); // Fix incorrect ref syntax
    //   let updates = {};
    
    
    //   try {
    //     const snapshot = await userRef.once('value');
    
    //     if (!snapshot.exists()) {
    //       return false;
    //     }
    
    //     const userData = snapshot.val();
    //     const pledgeStart = userData.pledgeStart || 0;
    //     const now = Date.now();
    //     let minSinceStart;
    
    //     if (pledgeStart) {
    //       minSinceStart = Math.floor((now - pledgeStart) / (1000 * 60)); // Round down to the nearest whole minute
    //     } else {
    //       minSinceStart = 20; // Default to 20 minutes if pledgeStart is missing
    //     }
    
    
    //     if (minSinceStart < 10) {
    //       return false;
    //     }
    
    //     updates[`/user/${uid}/pledgeStart`] = now;
    //     await firebase.database().ref().update(updates);
        
    
    //     return true;
    //   } catch (error) {
    //     return false;
    //   }
    // };
    
  //   async getPledgePercentage(pledge) {
  //     if (pledge < 450) return 0; // Default case for values below 450
  
  //     if (pledge < 1100) return pledge * 0.25;
  //     if (pledge < 1800) return pledge * 0.27;
  //     if (pledge < 2200) return pledge * 0.30;
  //     if (pledge < 4200) return pledge * 0.35;
  //     if (pledge < 7000) return pledge * 0.40;
  //     if (pledge < 10000) return pledge * 0.45;
  
  //     return pledge * 0.50; // For pledge >= 10000
  // }

  // async getPledgePercentage(pledge) {
  //   if (pledge < 450) return [0, 0];
  
  //   if (pledge < 1100) return [pledge * 0.25, pledge * (0.25)];
  //   if (pledge < 1800) return [pledge * 0.27, pledge * (0.23)];
  //   if (pledge < 2200) return [pledge * 0.30, pledge * (0.20)];
  //   if (pledge < 4200) return [pledge * 0.35, pledge * (0.15)];
  //   if (pledge < 7000) return [pledge * 0.40, pledge * (0.10)];
  //   if (pledge < 10000) return [pledge * 0.45, pledge * (0.05)];
  
  //   return [pledge * 0.50, pledge * (0)];
  // }

  // async getPledgePercentage(pledge) { // add 8% taken from thinklead
  //   if (pledge < 450) return [0, 0];
  
  //   if (pledge < 1100) return [pledge * 0.25, pledge * (0.33)];
  //   if (pledge < 1800) return [pledge * 0.27, pledge * (0.31)];
  //   if (pledge < 2200) return [pledge * 0.30, pledge * (0.28)];
  //   if (pledge < 4200) return [pledge * 0.35, pledge * (0.23)];
  //   if (pledge < 7000) return [pledge * 0.40, pledge * (0.18)];
  //   if (pledge < 10000) return [pledge * 0.45, pledge * (0.13)];
  
  //   return [pledge * 0.50, pledge * (0.8)];
  // }


  // async getPledgePercentage(pledge, pemail) { // add 8% taken from thinklead for liq
  //   if (pemail===any of the below) {
  //       // Ivan@lowveldservice.co.za
  //       // Louise@symphonia.net
  //       // johanhippo1508@gmail.com
  //       // zjhardware2010@gmail.com 
  //       // martin@martincrous.com
  //       // James@theritchiegroup.com
  //       // alhajmelamu@gmail.com
  //    } else
  //    {
  //      if (pledge < 450) return [0, 0];
  //      if (pledge < 1100) return [pledge * 0.25, pledge * (0.33)];
  //    }
  // }

  // async getPledgePercentage(pledge, pemail) {
  //   // Define the email list
  //   //'James@theritchiegroup.com',
  //   //'alhajmelamu@gmail.com',
  //   const emailList = [
  //     'Ivan@lowveldservice.co.za',
  //     'Louise@symphonia.net',
  //     'johanhippo1508@gmail.com',
  //     'zjhardware2010@gmail.com',
  //     'martin@martincrous.com',
  //   ];
  
  //   // Check if pemail is in the email list (case-insensitive for robustness)
  //   if (emailList.some(email => email.toLowerCase() === pemail.toLowerCase())) {
  //     return [pledge * 0.50, pledge * 0.32];
  //   } else {
  //     if (pledge < 395) return [0, 0];
  //     return [pledge * 0.25, pledge * 0.32];
  //   }
  // }

  async getPledgePercentage(pledge, pemail) {
    // Define the email list
    //'James@theritchiegroup.com',
    //'alhajmelamu@gmail.com',
    const emailList = [
      'Ivan@lowveldservice.co.za',
      'Louise@symphonia.net',
      'johanhippo1508@gmail.com',
      'zjhardware2010@gmail.com',
      'martin@martincrous.com',
    ];
  
    // Check if pemail is in the email list (case-insensitive for robustness)
    if (emailList.some(email => email.toLowerCase() === pemail.toLowerCase())) {
      return [pledge * 0.25, pledge * 0.25];
    } else {
      if (pledge < 395) return [0, 0];
      return [pledge * 0.25, pledge * 0.25];
    }
  }

  async processPledgeAllocations(pledge, dolive) {
    const db = firebase.database;
  
    // Step 1: Aggregate points by email
    const allocations = {
      'adriaan@leadershipplatform.com': (pledge * 0.07) + (pledge * 0.005), // MRFA + Ad
      'mychristo@gmail.com': (pledge * 0.02) + (pledge * 0.005), // MRFC + Chr
      // 'louis@leadershipplatform.com': pledge * 0.01, // Pa
      // 'rinagroen6@gmail.com': pledge * 0.002, // Ma
      // 'elmarie227@gmail.com': pledge * 0.005, // El
      // 'tinselslipperedfeet@gmail.com': pledge * 0.003, // Jan
      // 'alhajmelamu@gmail.com': pledge * 0.01, // Malik
    };
  
    // Step 2: Process updates for each user
    const updates = {};
    for (const [email, pointsAdd] of Object.entries(allocations)) {
      try {
        // Fetch user data from both collections
        const usersRef = db.ref('user');
        const usersRefB = db.ref('users');
        const emailQuery = usersRef.orderByChild('email').equalTo(email);
        const emailQueryB = usersRefB.orderByChild('email').equalTo(email);
  
        // Get UID from /user
        const snapshot = await emailQuery.get();
        if (!snapshot.exists()) {
          
          continue;
        }
        const userData = snapshot.val();
        const uid = Object.keys(userData)[0];
  
        // Get userID from /users
        const snapshotB = await emailQueryB.get();
        if (!snapshotB.exists()) {
          
          continue;
        }
        const userDataB = snapshotB.val();
        const userID = Object.keys(userDataB)[0];
  
        // Step 3: Use transactions to update points atomically
        const updatePoints = async (path) => {
          await db.ref(path).transaction((currentPoints) => {
            const newPoints = (Number(currentPoints) || 0) + Number(pointsAdd);
            
            return newPoints;
          });
        };
  
        // Perform updates for both paths
        if (dolive) {
          await Promise.all([
            updatePoints(`/user/${uid}/points`),
            updatePoints(`/users/${userID}/points`),
          ]);
        } else {
          
        }
      } catch (error) {
        
      }
    }
  
    
  }

async addMIF(email, pointsAdd, dolive) {
  var updates = {};
  var pointsSnapshot;
  var uid;
  var userID;
  var userData;

    
    const db = firebase.database;
    const usersRef = db.ref("user");
    const emailQuery = query(usersRef, orderByChild("email"), equalTo(email));

   

    try { //get uid and points
        const snapshot = await get(emailQuery);
        
        if (snapshot.exists()) {
            // Get the first user with the matching email
            
            userData = snapshot.val();
            uid = Object.keys(userData)[0]; // Get the first matching UID
            
            // Fetch points
             pointsSnapshot = await get(ref(db, `user/${uid}/points`));
              
           // return pointsSnapshot.exists() ? pointsSnapshot.val() : null;
        } else {
            
           // return null;
        }
    } catch (error) {
        
       // return null;
    }

    const usersRefB = db.ref("users");
    const emailQueryB = query(usersRefB, orderByChild("email"), equalTo(email));
    
    try {
      const snapshotB = await get(emailQueryB);
      
      if (snapshotB.exists()) {
        
          // Get the first user with the matching email
          const userDataB = snapshotB.val();
          userID = Object.keys(userDataB)[0]; // Get the first matching UID
          
      } else {
          
         // return null;
      }
  } catch (error) {
      
     // return null;
  }

 // const points = Number(pointsSnapshot) + Number(pointsAdd);
  const points = Number(pointsSnapshot.val() || 0) + Number(pointsAdd);

   updates['/users/' + userID + '/points'] = points;
   updates['/user/' + uid + '/points'] = points;

   console.log('Pledge log addMIF updates: ', updates);

  ////////////////////////////////////////////////////////////////////////
  if (dolive===true) {
      var ress = await axios.post(`${FB_URL}/m115-freshcard`, {
          params: {
              updates: updates, //user wallet address                       
          }
        })
 
       if (ress.data || ress.data.success === true) {
         console.log('Successfully updated addMIF in Main pledge');
       }
       else {
         console.error('Error updating addMIF in main pledge comp:', error);
       };  

  //  firebase.database.ref().update(
  //   updates,
  //   function (error) {
  //     if (error) {
        
  //     } else {
        
  //     }
  //   }
  // ); 
  }
     
    }

   ///////////////////////////////////////////////////////////////////////////////////////////
   //new code for only mychristo@gmail.com to confirm ALL pledges
   ///////////////////////////////////////////////////////////////////////////////////////////
    getUserDataByEmail_default = async (email) => {
      try {
        // Initialize database reference
        const db = firebase.database;
        const usersRef = db.ref('user');
        const emailQuery = query(usersRef, orderByChild('email'), equalTo(email));
    
        // Get user data
        const snapshot = await get(emailQuery);
    
        if (snapshot.exists()) {
          // Get the first user with the matching email
          const userData = Object.values(snapshot.val())[0];
    
          // Construct the response object with required fields
          const userInfo = {
            uid: userData.uid,
            userID: userData.userID,
            userWalletAddress: userData.wallet,
            companyID: userData.companyID,
            lastPay: userData.payoutdate,
            profileName: userData.userType,
            profile: userData.userDescription,
            companyName: userData.companyName,
            firstName: userData.firstName,
            lastName: userData.lastName,
            isPatron: userData.patron,
            patronPoints: userData.points
          };
          

          return userInfo;
        } else {
          // Return null or throw error if user not found
          throw new Error('User not found');
        }
      } catch (error) {
        
        throw error;
      }
    };

    getUserDataByEmail_def1 = async (email) => {
      try {
        // Normalize email input (lowercase and trim)
        const normalizedEmail = email.toLowerCase().trim();
        
    
        // Initialize database reference
        const db = firebase.database;
        const usersRef = db.ref('user');
        const emailQuery = query(usersRef, orderByChild('email'), equalTo(normalizedEmail));
    
        // Get user data
        const snapshot = await get(emailQuery);
    
        if (snapshot.exists()) {
          // Get all matching users and their keys (UIDs)
          const users = Object.values(snapshot.val());
          const userKeys = Object.keys(snapshot.val());
    
          // Log all matching users for debugging
          
    
          // Filter users where patron field exists
          const usersWithPatron = users
            .map((user, index) => ({
              data: user,
              uid: userKeys[index],
              payoutdate: user.payoutdate ? new Date(user.payoutdate).getTime() : 0, // Convert to timestamp
            }))
            .filter((user) => user.data.patron !== undefined);
    
          if (usersWithPatron.length === 0) {
            
            throw new Error('No user with patron field found');
          }
    
          // Select the newest user based on payoutdate or UID
          let selectedUser = usersWithPatron[0].data;
          let selectedKey = usersWithPatron[0].uid;
    
          if (usersWithPatron.length > 1) {
            
    
            // Sort by payoutdate (descending: newest first), then UID
            usersWithPatron.sort((a, b) => {
              if (a.payoutdate && b.payoutdate) {
                return b.payoutdate - a.payoutdate; // Newest payoutdate first
              }
              return b.uid.localeCompare(a.uid); // Newest UID first
            });
    
            // Log sorted records
            
    
            // Select the newest
            selectedUser = usersWithPatron[0].data;
            selectedKey = usersWithPatron[0].uid;
          }
    
          // Construct the response object
          const userInfo = {
            uid: selectedUser.uid || selectedKey,
            userID: selectedUser.userID || null,
            userWalletAddress: selectedUser.wallet || null,
            companyID: selectedUser.companyID || null,
            lastPay: selectedUser.payoutdate || null,
            profileName: selectedUser.userType || null,
            profile: selectedUser.userDescription || null,
            companyName: selectedUser.companyName || null,
            firstName: selectedUser.firstName || null,
            lastName: selectedUser.lastName || null,
            isPatron: selectedUser.patron || false,
            patronPoints: Number(selectedUser.points) || 0,
          };
    
          // Validate required fields
          if (!userInfo.uid || !userInfo.userID) {
            
            throw new Error(`Invalid user data for email ${normalizedEmail}`);
          }
    
          
          return userInfo;
        } else {
          
          throw new Error('User not found');
        }
      } catch (error) {
        
        throw error;
      }
    };

    getUserDataByEmail_def2 = async (email) => {
      try {
        // Normalize email input (lowercase and trim)
        const normalizedEmail = email.toLowerCase().trim();
        
    
        // Initialize database reference
        const db = firebase.database;
        const usersRef = db.ref('user');
        const emailQuery = query(usersRef, orderByChild('email'), equalTo(normalizedEmail));
    
        // Get user data
        const snapshot = await get(emailQuery);
    
        // Log raw snapshot for debugging
        
    
        if (snapshot.exists()) {
          // Get all matching users and their keys (UIDs)
          const users = Object.values(snapshot.val());
          const userKeys = Object.keys(snapshot.val());
    
          // Log all matching users for debugging
          
    
          // Map all users with payoutdate for sorting
          const userRecords = users.map((user, index) => ({
            data: user,
            uid: userKeys[index],
            payoutdate: user.payoutdate ? new Date(user.payoutdate).getTime() : 0,
          }));
    
          // Filter users where patron field exists
          let selectedUsers = userRecords.filter((user) => user.data.patron !== undefined);
    
          if (selectedUsers.length === 0) {
            
            // Fallback to all users if no patron field exists
            selectedUsers = userRecords;
          }
    
          if (selectedUsers.length === 0) {
            
            throw new Error('No valid user data found');
          }
    
          // Sort by payoutdate (descending: newest first), then UID
          selectedUsers.sort((a, b) => {
            if (a.payoutdate && b.payoutdate) {
              return b.payoutdate - a.payoutdate; // Newest payoutdate first
            }
            return b.uid.localeCompare(a.uid); // Newest UID first
          });
    
          // Log sorted records
          
    
          // Select the newest
          const selectedUser = selectedUsers[0].data;
          const selectedKey = selectedUsers[0].uid;
    
          // Construct the response object
          const userInfo = {
            uid: selectedUser.uid || selectedKey,
            userID: selectedUser.userID || null,
            userWalletAddress: selectedUser.wallet || null,
            companyID: selectedUser.companyID || null,
            lastPay: selectedUser.payoutdate || null,
            profileName: selectedUser.userType || null,
            profile: selectedUser.userDescription || null,
            companyName: selectedUser.companyName || null,
            firstName: selectedUser.firstName || null,
            lastName: selectedUser.lastName || null,
            isPatron: selectedUser.patron || false,
            patronPoints: Number(selectedUser.points) || 0,
          };
    
          // Validate required fields
          if (!userInfo.uid || !userInfo.userID) {
            
            throw new Error(`Invalid user data for email ${normalizedEmail}`);
          }
    
          
          return userInfo;
        } else {
          
          throw new Error('User not found');
        }
      } catch (error) {
        
        throw error;
      }
    };

    getUserDataByEmail = async (email) => {
      try {
        // Normalize email input (lowercase and trim)
        const normalizedEmail = email.toLowerCase().trim();
        const originalEmail = email.trim(); // Preserve original case
        // Capitalize first letter of email (e.g., louise@symphonia.net -> Louise@symphonia.net)
        const capitalizedEmail = normalizedEmail.replace(/^./, str => str.toUpperCase());
        
    
        // Initialize database reference
        const db = firebase.database;
        const usersRef = db.ref('user');
    
        // Helper function to query users by email
        const queryUsers = async (queryEmail) => {
          const emailQuery = query(usersRef, orderByChild('email'), equalTo(queryEmail));
          const snapshot = await get(emailQuery);
          
          return snapshot;
        };
    
        // Try normalized email first
        let snapshot = await queryUsers(normalizedEmail);
    
        // If no results, try original email case
        if (!snapshot.exists() && normalizedEmail !== originalEmail) {
          
          snapshot = await queryUsers(originalEmail);
        }
    
        // If no results, try capitalized email
        if (!snapshot.exists() && normalizedEmail !== capitalizedEmail) {
          
          snapshot = await queryUsers(capitalizedEmail);
        }
    
        if (snapshot.exists()) {
          // Get all matching users and their keys (UIDs)
          const users = Object.values(snapshot.val());
          const userKeys = Object.keys(snapshot.val());
    
          // Log all matching users for debugging
          
    
          // Map all users with payoutdate for sorting
          const userRecords = users.map((user, index) => ({
            data: user,
            uid: userKeys[index],
            payoutdate: user.payoutdate ? new Date(user.payoutdate).getTime() : 0,
          }));
    
          // Filter users where patron field exists
          let selectedUsers = userRecords.filter((user) => user.data.patron !== undefined);
    
          if (selectedUsers.length === 0) {
            
            // Fallback to all users if no patron field exists
            selectedUsers = userRecords;
          }
    
          if (selectedUsers.length === 0) {
            
            throw new Error('No valid user data found');
          }
    
          // Sort by payoutdate (descending: newest first), then UID
          selectedUsers.sort((a, b) => {
            if (a.payoutdate && b.payoutdate) {
              return b.payoutdate - a.payoutdate; // Newest payoutdate first
            }
            return b.uid.localeCompare(a.uid); // Newest UID first
          });
    
          // Log sorted records
          
    
          // Select the newest
          const selectedUser = selectedUsers[0].data;
          const selectedKey = selectedUsers[0].uid;
    
          // Construct the response object
          const userInfo = {
            uid: selectedUser.uid || selectedKey,
            userID: selectedUser.userID || null,
            userWalletAddress: selectedUser.wallet || null,
            companyID: selectedUser.companyID || null,
            lastPay: selectedUser.payoutdate || null,
            profileName: selectedUser.userType || null,
            profile: selectedUser.userDescription || null,
            companyName: selectedUser.companyName || null,
            firstName: selectedUser.firstName || null,
            lastName: selectedUser.lastName || null,
            isPatron: selectedUser.patron || false,
            patronPoints: Number(selectedUser.points) || 0,
          };
    
          // Validate required fields
          if (!userInfo.uid || !userInfo.userID) {
            
            throw new Error(`Invalid user data for email ${normalizedEmail}`);
          }
    
          
          return userInfo;
        } else {
          
          throw new Error('User not found');
        }
      } catch (error) {
        
        throw error;
      }
    };

   async componentDidMount() {
      await this.confirmPledge();
   }

  confirmPledge = async () => {
    // Check if the function has already run in this session
    if (localStorage.getItem('pledgeconfirmed') === 'true') {     
      return;
    }
  
    var uid;
    var userID;
    var userEmail;
    var userEmail_trim;
    var emailT;
    var emailA = [];
    var companyID;
    var doUpdates = false;
    var userwalletaddress;
    var skipUser = false;
    var pledge;
    var totPledge = 0;
    var countPledge = 0;
    var trans = false;
    var companyName;
    var firstName;
    var lastName;
    var updates = {};
    var pledgeStart;
    var lastPledgeDate;
    var lastPay;
    var profile_n;
    var profile;
    var isPatron;
    var points;
    var GIF_pool = 0;
    var ress;
    //////////////////
    var dolive = false;
    //////////////////

    //const adminAcc = "mychristo@gmail.com";
    const adminAcc = "kriskraai127@gmail.com";

    if (this.props.userdata.email.toLowerCase() !== adminAcc) {
      
      return;
    }
  
   // if (window.location.href.includes('/gotopatreon')) {
    if (window.location.href==='http://localhost:3000/gotopatreon') {
      this.handlePatreonAuth();
      
      return;
    }
   
    try {
      var url1 = window.location.href;
      var urlx = url1.substring(url1.indexOf("=") + 1, url1.lastIndexOf("&"));
      const oauthGrantCodex = urlx;
           
      const res = await axios.post(`${FB_URL}/m105-getpatreon`, {
        params: {
          code: oauthGrantCodex,
          n: '111',
          inc: '11698007',
          type: 'GotoPatreon'
        },
      });
  
     console.log('oauthGrantCode-6 ', res);

      emailA = res.data.emails[0];
      const emailB = res.data.emails;
     // var count = Object.keys(emailA).length;
      var countb = Object.keys(emailB).length;

  for (let i = 0; i < countb; i++) {
    emailT = emailB;
    userEmail = emailT[i].email;
    userEmail_trim = String(userEmail.trim()).toLowerCase();

    var skip_email = false;
    //////////////////////////////////////////////////////////
    // if (
    //     userEmail_trim==="johanbester55@gmail.com" ||
    //     userEmail_trim==="johanhippo1508@gmail.com" ||
    //     userEmail_trim==="maletjile@gmail.com" ||
    //     userEmail_trim==="r.tyler.ritchie@gmail.com" ||
    //     userEmail_trim==="viljoen31@gmail.com" ||
    //     userEmail_trim==="ivan@lowveldservice.co.za" ||
    //     userEmail_trim==="zjhardware2010@gmail.com" ||
    //     userEmail_trim==="bryan@artibeus.com" ||
    //     userEmail_trim==="mandisaseleoane@gmail.com"
    // ) {skip_email=true}
    // console.log('MainPledge skip : ', skip_email);
  ////////////////////////////////////////////////////////////
    
    if (emailT[i].patronStatus !== 'active_patron' || skip_email===true) {
      // skip
    } else {
      // valid patron — userEmail_trim already computed above, just use it

      let patronData;
      try {
        patronData = await this.getUserDataByEmail(userEmail_trim);
          
          uid = patronData.uid;
          userID = patronData.userID;
          userwalletaddress = patronData.userWalletAddress;
          companyID = patronData.companyID;
          lastPay = patronData.lastPay;
          profile_n = patronData.profileName;
          profile = patronData.profile;
          isPatron = patronData.isPatron;
          points = patronData.patronPoints;
          companyName = patronData.companyName;
          firstName = patronData.firstName;
          lastName = patronData.lastName;
               
        } catch (error) {
          
          continue;
        }
  
        doUpdates = true;
        //pledge = emailT.amountCents;
        pledge = emailT[i].amountCents;

        if (doUpdates) {
          var newPay;
          var dateA;
          var dateB;
          var newPayBool;
          var timeNow = new Date();
          var pledge_pers_pool;
          var Malik;
          var thinkLead;
          var MRFA;
          var MRFC;
          var Pa;
          var Ma;
          var El;
          var Jan;
          var Ad;
          var Chr;
          var AdFull;
          var ChrFull;
          var Richie;

          if (profile_n === 8 || profile_n === "8") {
            profile_n = 3;
            profile = 'Public Contributor';
          }
  
          if (lastPay && isPatron) {
            dateA = lastPay;
            dateB = timeNow.getMonth();
            newPay = dateB;
            newPayBool = dateA !== dateB;
            
          } else {
            newPay = timeNow.getMonth();
            newPayBool = true;
            
          }
  
          if (pledge > 400) {
            var real_pledge = pledge - (pledge * 0.12);
            pledge = real_pledge;
            totPledge = totPledge + pledge;

            const pemail = userEmail_trim;
  
            let pledge_pers, liq;
            try {
              [pledge_pers, liq] = await this.getPledgePercentage(pledge, pemail);
              
            } catch (error) {
              
              continue;
            }
  
            // Validate pledge_pers and points
            const parsedPoints = Number(points);
            const parsedPledgePers = Number(pledge_pers);
             
            if (isNaN(parsedPoints) || isNaN(parsedPledgePers)) {            
              continue;
            }
  
            thinkLead = pledge * (0.12 - 0.000909091);
            MRFA = pledge * (0.07 - 0.003181818);
            MRFC = pledge * (0.02 - 0.000909091);
            /////////////////////
            Pa = pledge * 0.01;
            Ma = pledge * 0.002;
            El = pledge * 0.005;
            Jan = pledge * 0.003;
            Ad = pledge * 0.005;
            Chr = pledge * 0.005;
            Malik = pledge * 0.01;
            //MIF/////////////////
            Richie = pledge * 0.005;
            //////////////////////
            AdFull = MRFA + Ad;
            ChrFull = MRFC + Chr;

            countPledge = countPledge + pledge;
            ////////////////////////////////////////////////////////////////////
              await this.addMIF('louis@leadershipplatform.com', Pa, dolive);
              await this.addMIF('rinagroen6@gmail.com', Ma, dolive);
              await this.addMIF('elmarie227@gmail.com', El, dolive);
              await this.addMIF('tinselslipperedfeet@gmail.com', Jan, dolive);

              await this.addMIF('adriaan@leadershipplatform.com', AdFull, dolive);
              await this.addMIF('mychristo@gmail.com', ChrFull, dolive);

              await this.addMIF('alhajmelamu@gmail.com', Malik, dolive);
              //MIF//////////////////////////////////////////////////////////////
              await this.addMIF('r.tyler.ritchie@gmail.com', Richie, dolive);
              ///////////////////////////////////////////////////////////////////
              // Calculate total points for each user to avoid multiple updates         

            pledge_pers_pool =
              Number(pledge) -
              Number(pledge_pers) -
              Number(thinkLead) -
              Number(MRFA) -
              Number(MRFC) -
              Number(Pa) -
              Number(Ma) -
              Number(El) -
              Number(Jan) -
              Number(Ad) -
              Number(Chr) -
              Number(Malik) -
              Number(Richie)
             // Number(liq)
  
            
            GIF_pool = GIF_pool + pledge_pers_pool;

            await new Promise((resolve) => setTimeout(resolve, 3000));
  
            // Calculate newPoints with validated values
            var newPoints = parsedPoints + parsedPledgePers;
            
  
            const getPatData = {
              profile_n,
              profile,
              pledge,
              newPay,
              points: newPoints,
              pledge_pers,
              userPoints: points,
              userEmail_trim,
            };
            
  
            var trailID = this.makeid(10);
            var now = new Date();
            var isoString = now.toISOString();
            ////////////////////////////////////////////////////////////////////////////

          const res = await axios.post(`${FB_URL}/m122-centraltime`, {});

          if (res.data?.success === true && typeof res.data.timestamp === 'number') {
            lastPledgeDate = new Date(res.data.timestamp);
          } else {
            console.warn("Failed to get central time", res.data);
            // Fallback strategy: use moment locally (less secure but better than nothing)
             const timeRaw = moment().tz('Africa/Johannesburg');        
             lastPledgeDate = timeRaw.format('YYYY-MM-DD HH:mm'); 
          }

            /////////////////////////////////////////////////////////////////////////// 
            if (!skipUser) {
              updates[`/users/${userID}/userDescription`] = profile;
              updates[`/users/${userID}/userType`] = profile_n;
              updates[`/users/${userID}/companyID_userType`] = `${companyID}_${profile_n}`;
              updates[`/user/${uid}/userDescription`] = profile;
              updates[`/user/${uid}/userType`] = profile_n;
              updates[`/user/${uid}/companyID_userType`] = `${companyID}_${profile_n}`;
            }
  
            updates[`/users/${userID}/feedbackOn`] = true;
            updates[`/users/${userID}/gfeedbackOn`] = true;
            updates[`/users/${userID}/execmember`] = true;
            updates[`/users/${userID}/patron`] = true;
            updates[`/users/${userID}/pledge`] = pledge;
            updates[`/users/${userID}/payoutdate`] = newPay;
            updates[`/users/${userID}/lastPledgeDate`] = lastPledgeDate;
            updates[`/users/${userID}/lastPledgeType`] = 'Pledge confirmed';
            updates[`/users/${userID}/points`] = newPoints;
  
            updates[`/user/${uid}/feedbackOn`] = true;
            updates[`/user/${uid}/gfeedbackOn`] = true;
            updates[`/user/${uid}/execmember`] = true;
            updates[`/user/${uid}/patron`] = true;
            updates[`/user/${uid}/pledge`] = pledge;
            updates[`/user/${uid}/payoutdate`] = newPay;
            updates[`/user/${uid}/lastPledgeDate`] = lastPledgeDate;
            updates[`/user/${uid}/lastPledgeType`] = 'Pledge confirmed';
            updates[`/user/${uid}/points`] = newPoints;
  
            const pts = Number(pledge_pers) / 100; //patron
            const ptsB = `${pts} Lc`;
            const Gpts = Number(pledge_pers_pool) / 100; //GIF

            const currLc = Number(newPoints) / 100; 

            updates[`/pointsTrail/${trailID}`] = {
              userID,
              fdate: lastPledgeDate,//timeNow,
              trailID,
              companyName,
              firstName,
              lastName,
              title: 'Pledge converted',
              actionType: 'Pledge confirmed',
              // actionType: pts > 0
              //   ? `${pts} Lc earned from Pledge.`
              //   : 'Pledge not converted to LC',
              actionDesc: pts > 0
                ? `Lc earned from Pledge`
                : 'Pledge not converted to LC',
              pointsAdded: ptsB,
              pointsCurrent: currLc,
              gas: 0
            };
  
            updates[`/MEVDATA/${trailID}`] = {
              userID,
              fdate: lastPledgeDate,//timeNow,
              trailID,
              companyName,
              firstName,
              lastName,
              actionType: 'Pledge confirmed',
              title: pts > 0
                ? `${pts} Lc earned from Pledge.`
                : 'Pledge not converted to LC',
              actionDesc: pts > 0
                ? `Lc earned from Pledge`
                : 'Pledge not converted to LC',
              pointsAdded: Gpts,
              pointsCurrent: 0,
              gas: 0
            };            

           if (dolive===true) {             
                 ress = await axios.post(`${FB_URL}/m115-freshcard`, {
                    params: {
                        updates: updates, //user wallet address                       
                    }
                  })

              if (ress.data || ress.data.success === true) {
                console.log('Successfully updated pledge');
                console.log('MainPledge log names true: ', firstName + ' ' + lastName + ' ' + userEmail_trim);
              }
              else {
                console.error('Error updating main pledge comp:', error);
              };

           }
            
        console.log('MainPledge test: ', firstName + ' ' + lastName + ' ' + userEmail_trim);

              // GIF_pool:  48378   
             //////////////////////////////////////////////////////////
             //GIF_Tot GIF_pool:   48378  Lc - 18689 Lc = 29689 Lc
             //Malik super pledge: 115743 Lc
             //-----------------------------
             //GIF now = $483.78 + $1157.43 = $1641.21 = R29828,99   

        console.log('MainPledge updates: ', updates);
        console.log('MainPledge pledge_pers_pool: ', pledge_pers_pool);

            updates = {};
            
          if (dolive===true) {
           //////////////////////////////////////////////////////////////////////////// 
            console.log('GotoPersonPledge start 1');          
           await axios.post(
                'https://us-central1-leadershipplatform-158316.cloudfunctions.net/m117-addToLCPool',
                {
                  params: { amount: pledge_pers_pool }   // ← keep old structure
                }
              );     
              console.log('MainPledge start 2', pledge_pers_pool);  

              if (ress.data || ress.data.success === true) {
                console.log('MainPledge Successfully updated pledge');
                console.log('MainPledge Pledge log names true: ', firstName + ' ' + lastName + ' ' + userEmail_trim);
              }
              else {
                console.error('MainPledge Error in confriming pledge');
              };
           }
            
            await new Promise((resolve) => setTimeout(resolve, 3000));
          }
        }
       }
      }
      //update totPledge
      //update MEVinfo with totPledge/////////////////////////////////////////////////////
         var bupdates = {}
         bupdates['/MEVinfo/TOTpledge'] = totPledge; //database points - not Lc
         var rez = await axios.post(`${FB_URL}/m115-freshcard`, {
              params: {
                  updates: bupdates, //user wallet address                       
              }
            })

        if (rez.data || rez.data.success === true) {
         console.log('MainPledge totPledge is :', totPledge);
        }
        else {
          console.error('Error updating totPledge:', error);
        };
      ////////////////////////////////////////////////////////////////////////////////////
      localStorage.setItem('patreonAuthorizationDone', 'true');
      localStorage.setItem('pledgeconfirmed', 'true');
      
    } catch (err) {
       console.error('Error in gotopatreon :', err);
    }
  };


  handlePatreonAuth = () => {  //original DEFAULT Old path
    console.log('getpatrons-handlePatreonAuth 2 : ');  
   // const REDIRECT_URI = `${window.location.origin}/gotopatreon`; 
    const REDIRECT_URI = 'http://localhost:3000/gotopatreon';
    //const REDIRECT_URI = 'https://thinklead.app/gotopatreon';
    const CLIENT_ID = 'JainCEYNTU3DNmmnL3-npAQycVy88An8urdmbQefXDUxlm262IB8cM9xs2j1cLld';
    //const CLIENT_ID = 'tjyO6BK_Czgorkem1ulfH0Urogrf0Dlem9kMNZ8jUSEwPVzvsKcVy1g6UtrmsVne';

    window.location.href = `https://www.patreon.com/oauth2/authorize?response_type=code&client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}`;
  };

  async componentDidUpdate(prevProps, prevState) {
    if (this.props.location !== prevProps.location) {
      const oauthGrantCode = this.getOAuthcodeB();
      if (oauthGrantCode) {
          
        //this.setState({oauthGrantCode: true})
        try {
          await axios
          .post(`${FB_URL}/m105-getpatreon`, {params: { 
             code: oauthGrantCode, 
             n: '111', 
             inc: '777' 
            } })
          .then(res => {
                 
              // Set a flag to indicate that Patreon authorization is done
              localStorage.setItem('patreonAuthorizationDone', 'true');
          })
         }
          catch(err) {
            }
      } else {
        
      }
    }
  }

  getOAuthcodeB = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('code');
  };

//////////////////////////////////////////////////////////////////////////////////////////

  handleOpen = url => {
    window.open(url, '_blank')
  };

  async sendGetRequest(cemail, props, status) {
    const { simpleValAction2, checkToken } = this.props
    

    var code
    const data = {
      username: 'ZGYrTGlJc3VoZTZhbDZacmZrSHNDbW5iOTFTaXJha1pnbHY5Qkt2bDJWMD0=',
      password: 'AQ2GD&*Q'
    }
    const options = {
      method: 'POST',
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      data: qs.stringify(data),
      url: 'https://mp.exec-club.com/api/auth/session-create'
    }

   await axios(options)
      .then(function (response) {
        const data = {
          email_id: cemail
        }
        const xoptions = {
          method: 'POST',
          headers: {
            'Content-type': 'application/json',
            'Token': response.data.token
          },
          data: data,
          url: 'https://mp.exec-club.com/api/validate-user'
        }
       axios(xoptions)
          .then(res => {
            
            code = res.data.login_url
            if (code && code !== undefined) {
              // ///////////////////////////////reached here means EXECUTIVE CLUB member

              if (status === '2') {
                
                let body = {
                  type: SIMPLE_VAL2,
                  surveyid: true,
                  go: true
                }
                 simpleValAction2(body)
              }

              if ( status === '3' || status === '1') {
                
                let params = {
                  type: SHOW_CALF,
                  code: code,
                  uid: props.userdata.uid,
                  userID: props.userdata.userID,
                  companyID: props.userdata.companyID,
                  userType: props.userdata.userType
                }
                props.showCalf(params)
                //if (status === '1') {
                window.open(res.data.login_url, '_blank')
                //}
              }
              } else {
              }
          })
          .catch(error => {
            return 2
          })
          .catch(function (error) {
            return 3
          })
      })
      .catch(function (error) {
        return 3
      })
  }

  preSubmit = () => {

    this.handleSubmitUser({
          tokenType:this.state.tokenType,
          amount: this.state.amount
      });

   }

  render() {
    const { calf } = this.props
     
    if (this.props.userdata.execmember === false) { // NOT SUBSCRIBED

      return (
                <React.Fragment>
                  <div style={{
                    display: 'block',
                    // marginLeft: isMobile ? "10px" : "0px",
                    backgroundColor: '#FFFBE6',
                    color: '#695800',
                    padding: '20px',
                    width: isMobile ? '100%' : '80%',
                    size: '16px',
                  }}>
                        <h3>Me Vision</h3>
                        <p style={{ textAlign: "justify", display: "block" }}><a style={{ fontSize: "1.5em", fontWeight: "strong" }}>ME-Vision Academy</a> is about a journey to Authentic Self-Confidence, 
                            which we refer to as <b>“Best-Self Confidence”</b>. 
                            Everyone needs and wants it. You want and need it for yourself, your children and employees. 
                            We help individuals, from technical specialists all the way through to senior leadership, 
                            to become and remain Best-Self Confident throughout their life and career.
                            Let us assist you, your family and your employees.</p>
        
                       <p style={{ textAlign: "justify", display: "block" }}>
                            <b>In a world facing turbulence</b>, the demand for successful leaders is 
                            more critical than ever. While many advocate for developing more 
                            leaders, which should not be neglected, we believe there are many 
                            more existing successful leaders that we are unaware of, across 
                            all levels of organisations. Launching an international drive to 
                            spotlight this influential group could reshape societies. 
                            It's time to discover, acknowledge, and <i>empower successful leaders </i>
                            across the board, with the vital mission of fostering more 
                            successful leaders.
                        </p>
                        <p style={{ textAlign: "justify", display: "block" }}>
                            While tracking the success of visible leaders is straightforward, 
                            the challenge lies in recognizing the less visible ones, especially 
                            because performance only isn't sufficient. To bridge this gap, 
                            <b>we introduce "LeaderTrack," a technology that monitors a leader's 
                            prowess real-time</b>, categorised by leadership levels, sectors, 
                            and countries. Upon qualification, the leader receives an exclusive 
                            Successful Leadership Certificate from ME-Vision Academy, renewable 
                            annually. If an organisation partners with us and has a reliable 
                            and credible process of identifying and tracking their successful 
                            leaders, we go with their data and place their qualifying leaders 
                            on their own branded LeaderTrack.
                        </p>
                        <p style={{ textAlign: "justify", display: "block" }}>
                            Our journey has crystallized into a vision: #30000SuccessfulLeaders 
                            by 2030. Imagine mobilizing so many truly successful leaders on one 
                            platform, customised by organisations and clearly identified by 
                            levels, sectors (industries) and countries—our dream is to mobilise 
                            100,000. With your support, even the dream can become a reality. 
                            <i>Are you one of the #30000SuccessfulLeaders?</i>
                        </p>
                        <p style={{ textAlign: "justify", display: "block" }}>
                           <i> If you wish to join this audacious yet vital mission, engage with 
                            us on any of these days for a discussion on the way forward - 
                            individually or as an organisation.</i>
                            </p>

                  </div>
                </React.Fragment>

      )
    }
    else { //SUBSCRIBED YES

      return (
        <React.Fragment>
        <div style={{
          display: 'block',
          // marginLeft: isMobile ? "10px" : "0px",
          backgroundColor: '#FFFBE6',
          color: '#695800',
          padding: '20px',
          width: isMobile ? '100%' : '80%',
          size: '16px',
        }}>
              <h3>Me Vision</h3>
              <p style={{ textAlign: "justify", display: "block" }}><a style={{ fontSize: "1.5em", fontWeight: "strong" }}>ME-Vision Academy</a> is about a journey to Authentic Self-Confidence, 
                  which we refer to as <b>“Best-Self Confidence”</b>. 
                  Everyone needs and wants it. You want and need it for yourself, your children and employees. 
                  We help individuals, from technical specialists all the way through to senior leadership, 
                  to become and remain Best-Self Confident throughout their life and career.
                  Let us assist you, your family and your employees.</p>

             <p style={{ textAlign: "justify", display: "block" }}>
                  <b>In a world facing turbulence</b>, the demand for successful leaders is 
                  more critical than ever. While many advocate for developing more 
                  leaders, which should not be neglected, we believe there are many 
                  more existing successful leaders that we are unaware of, across 
                  all levels of organisations. Launching an international drive to 
                  spotlight this influential group could reshape societies. 
                  It's time to discover, acknowledge, and <i>empower successful leaders </i>
                  across the board, with the vital mission of fostering more 
                  successful leaders.
              </p>
              <p style={{ textAlign: "justify", display: "block" }}>
                  While tracking the success of visible leaders is straightforward, 
                  the challenge lies in recognizing the less visible ones, especially 
                  because performance only isn't sufficient. To bridge this gap, 
                  <b>we introduce "LeaderTrack," a technology that monitors a leader's 
                  prowess real-time</b>, categorised by leadership levels, sectors, 
                  and countries. Upon qualification, the leader receives an exclusive 
                  Successful Leadership Certificate from ME-Vision Academy, renewable 
                  annually. If an organisation partners with us and has a reliable 
                  and credible process of identifying and tracking their successful 
                  leaders, we go with their data and place their qualifying leaders 
                  on their own branded LeaderTrack.
              </p>
              <p style={{ textAlign: "justify", display: "block" }}>
                  Our journey has crystallized into a vision: #30000SuccessfulLeaders 
                  by 2030. Imagine mobilizing so many truly successful leaders on one 
                  platform, customised by organisations and clearly identified by 
                  levels, sectors (industries) and countries—our dream is to mobilise 
                  100,000. With your support, even the dream can become a reality. 
                  <i>Are you one of the #30000SuccessfulLeaders?</i>
              </p>
              <p style={{ textAlign: "justify", display: "block" }}>
                 <i> If you wish to join this audacious yet vital mission, engage with 
                  us on any of these days for a discussion on the way forward - 
                  individually or as an organisation.</i>
                  </p>

        </div>
      </React.Fragment>

      )
    }
  }
}

const mapStateToProps = state => {
  return {
    userdata: state.userDialog.userDetails[0],
    calf: state.calf.calf,
    onething: state.oneVal2.sVal2,
    mytoken: state.mainToken.mtoken,
    adminAcc: state.mainToken.oadmin,
    tokenRequested: state.hasToken.hasToken
    // onething: state.sVal
    // simplething: state.simpleVal.simplething
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showCalf: params => dispatch(showCalf(params)),
    getMyToken: params => dispatch(getMyToken(params)),
    convertToken: params => dispatch(convertToken(params)),
    createToken: params => dispatch(createToken(params)),
    simpleValAction2: params => dispatch(simpleValAction2(params)),
    getAdmin: params => dispatch(getAdmin(params)),
    checkToken: params => dispatch(checkToken(params)),
    showToast: params => dispatch(showToast(params)),
    signOut: () => dispatch(signOut())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Gotopatreon)
